if ( archivoUsado == 'validar-negocio.php' && typeof paypal !== 'undefined' ) {
    paypal.Buttons( {
        createOrder: function () {
            return $.ajax( {
                url: 'api/pago/order',
                method: 'POST',
                dataType: 'json',
            } ).then( function ( datos ) {
                if ( datos.status == 'Success' ) {
                    return datos.data.id;
                } else {
                    let msg = idioma == 'es' ? 'Error al crear la orden: ' : 'Error creating order: ';
                    alerta( msg, error, false );
                }
            } );
        },
        onApprove: function ( data ) {
            console.log( data );
            return $.ajax({
                url: 'api/pago/capture',
                method: 'POST',
                dataType: 'json',
                data: { orderID: data.orderID }
            } ).then(function( datos ) {
                if ( datos.status == 'Success' ) {
                    let msg = idioma == 'es' ? 'Pago capturado con éxito, en breve te contactaremos para proceder' : 'Payment captured successfully, we will contact you shortly to proceed';
                    alerta( msg, '', false );
                } else {
                    let msg = idioma == 'es' ? 'Error al capturar el pago: ' : 'Error capturing payment: ';
                    alerta( msg, datos.message, false );
                }
            } );
        },
        onError: function( err ) {
            console.error(err);
        }
    } ).render('#paypal-button-container');
}